var React = require('react');

function RealIps (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"64/data"},[React.createElement("rect",{"width":"48","height":"48","rx":"8","fill":"#D7D4FF","key":0}),React.createElement("path",{"id":"Vector","d":"M32 30C33.1 30 33.99 29.1 33.99 28L34 18C34 16.9 33.1 16 32 16H16C14.9 16 14 16.9 14 18V28C14 29.1 14.9 30 16 30H12V32H36V30H32ZM16 18H32V28H16V18Z","fill":"#676D73","key":1})]));
}

RealIps.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = RealIps;

RealIps.default = RealIps;
